import React, { useState } from 'react';
import { useTranslation } from '../../../i18n';
import './PlanYourTripButton.css';

interface PlanYourTripButtonProps {
  onClick?: () => void;
  variant?: 'brand' | 'atacama' | 'iguazu' | 'mendoza' | 'patagonia' | 'santa-catarina';
  color?: 'awasi' | 'white';
  className?: string;
}

export const PlanYourTripButton: React.FC<PlanYourTripButtonProps> = ({
  onClick,
  variant = 'brand',
  color = 'awasi',
  className = ''
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const { t } = useTranslation();

  // Map variant names for Santa Catarina (file has space in name)
  const fileVariant = variant === 'santa-catarina' ? 'santa catarina' : variant;
  
  // Construct the SVG file paths
  const defaultImagePath = `/Plan Your Trip Buttons/state=Default, color=${color}, level=${fileVariant}.svg`;
  // For white buttons, use awasi hover state
  const hoverColor = color === 'white' ? 'awasi' : color;
  const hoverImagePath = `/Plan Your Trip Buttons/state=hover, color=${hoverColor}, level=${fileVariant}.svg`;

  return (
    <button
      className={`plan-your-trip-button plan-your-trip-button--${variant} plan-your-trip-button--${color} ${className}`}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      aria-label={t('common:buttons.planYourTrip')}
    >
      <svg 
        className="plan-your-trip-button__svg"
        preserveAspectRatio="xMidYMid meet"
        viewBox="0 0 290 55"
      >
        <image 
          href={isHovered ? hoverImagePath : defaultImagePath}
          x="0" 
          y="0" 
          width="290" 
          height="55"
          preserveAspectRatio="xMidYMid meet"
        />
      </svg>
    </button>
  );
};